import { Box, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { ToggleButton } from 'components/lib/ToggleButton';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import {
  ToggleButtonsGroupGridStyle,
  ToggleButtonsGroupTitleStyle,
} from './ToggleButtonsGroup.styles';
import type { ToggleButtonsGroupProps } from './ToggleButtonsGroup.types';

const ToggleButtonsGroup: FC<ToggleButtonsGroupProps> = ({
  title,
  options,
  value,
  inputVariant = 'radio',
  isReadOnly,
  testPrefix,
  ...rest
}) => (
  <>
    {title && (
      <Typography variant="h2" sx={ToggleButtonsGroupTitleStyle}>
        {title}
      </Typography>
    )}

    <ToggleButtonGroup
      {...rest}
      exclusive={inputVariant === 'radio'}
      value={value ?? []}
      sx={[ToggleButtonsGroupGridStyle, ...castArray(rest.sx)]}
      data-test={testPrefix}
    >
      {options?.map((option) => {
        const { tooltip, ...optionWithoutTooltip } = option;
        const toggleButtonProps = {
          ...optionWithoutTooltip,
          inputVariant,
          active: value && value.includes(option.value),
          disabled: isReadOnly || option.disabled,
          'data-test': `${testPrefix}_${option.value}`,
        };

        return tooltip ? (
          <Tooltip key={option.label} title={tooltip} placement="top" arrow>
            <Box
              component="span"
              style={{
                display: 'grid',
                gridColumn: option.fillType === 'full' ? 'span 2' : 'span 1',
              }}
            >
              <ToggleButton {...toggleButtonProps} />
            </Box>
          </Tooltip>
        ) : (
          <ToggleButton key={option.label} {...toggleButtonProps} />
        );
      })}
    </ToggleButtonGroup>
  </>
);

export default ToggleButtonsGroup;
